.spinner-container{position:fixed;top:0;left:0;width:100%;height:100%;background-color:#ffffffb3;display:flex;justify-content:center;align-items:center;z-index:9999}
/*# sourceMappingURL=spinner.component-M6YO7DYL.css.map */
